export default __webpack_public_path__ + "static/media/boschsans_boldItalic.e0b7a4f9.woff";